import { useEffect, useRef } from 'react';

export const useOutsideClick = <T extends HTMLElement>(
	callback: () => void,
	excludeRefs: React.RefObject<HTMLElement>[] = []
) => {
	const ref = useRef<T | null>(null);

	useEffect(() => {
		const handleClick = (event: MouseEvent) => {
			const target = event.target as Node;

			const isExcluded = excludeRefs.some((excludeRef) =>
				excludeRef.current?.contains(target)
			);

			if (ref.current && !ref.current.contains(target) && !isExcluded) {
				callback();
			}
		};

		document.addEventListener('click', handleClick, true);

		return () => {
			document.removeEventListener('click', handleClick, true);
		};
	}, [callback, excludeRefs]);

	return ref;
};
